import { render, staticRenderFns } from "./GiftCardListado.vue?vue&type=template&id=b4049752"
import script from "./GiftCardListado.vue?vue&type=script&lang=js"
export * from "./GiftCardListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports